import {
  AddSharp,
  EditSharp,
  FileDownload,
  RefreshSharp
} from "@mui/icons-material";
import {
  Avatar,
  Box,
  Button,
  Card,
  CardActions,
  CardContent,
  CardHeader,
  Grid,
  IconButton,
  Tooltip,
  Typography
} from "@mui/material";
import { useTheme } from "@mui/material/styles";
import MaterialReactTable from "material-react-table";
import { useContext, useEffect, useMemo, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from 'react-router-dom';
import * as XLSX from "xlsx";
import axios from "../axiosInstances";
import { ShoppingCartContext } from "./Context/ShoppingCartContext";
import SettingModel from "./SettingModel";

function SettingComp(props) {
  const navigate = useNavigate();
  const theme = useTheme();
  const [update, setUpdate] = useState(false);
  const [settingList, setSettingList] = useState([]);
  const { setPageHeader, globalUser, globalToken } = useContext(ShoppingCartContext)

  const { t, i18n } = useTranslation();

  const columns = useMemo(
    () => [
      {
        header: "Type",
        accessorKey: "Type",
      },
      {
        header: "Description",
        accessorKey: "Description",
      },
      {
        header: "Value",
        accessorKey: "Value",
      },
      {
        header: "Remark",
        accessorKey: "Remark",
      },

    ],
    []
  );



  const loadSettingList = () => {

    axios.get("/settings?Parent=" + globalUser.Parent, {
      headers: {
        token: globalToken,
      },
    }).then(response => {
      if (response.data.data) {
        setSettingList(response.data.data);
      } else {
        alert('log out and log in again33')
      }
    })

  };


  const handleUploadFile = async (e) => {
    const file = e.target.files[0];
    const data = await file.arrayBuffer();
    const workbook = XLSX.read(data);
    const worksheet = workbook.Sheets[workbook.SheetNames[0]];
    var jsonData = XLSX.utils.sheet_to_json(worksheet);

    var fdata = new FormData();
    fdata.append("JsonData", JSON.stringify(jsonData));
    await axios.post("/items/Excel", fdata, {
      headers: {
        "Content-Type": "application/json",
        token: globalToken,
      },
    });
  };
  function handleDownloadFile() {
    const worksheet = XLSX.utils.json_to_sheet(settingList);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "setting");
    //let buf = XLSX.write(workbook, { bookType: "xlsx", type: "buffer" });
    XLSX.write(workbook, { bookType: "xlsx", type: "binary" });
    XLSX.writeFile(workbook, "settingdata.xlsx");
  }




  useEffect(() => {
    if (!globalUser) {
      navigate('/');
      return;
    }
    setPageHeader('Setting')
    loadSettingList();
  }, [update]);
  return (

    <Grid container>


      <Grid item className="hideInMobile" m={1}>

        <MaterialReactTable
          columns={columns}
          data={settingList}
          initialState={{
            density: "compact",
            pagination: {
              pageIndex: 0,
              pageSize: 20,
            }
            , grouping: ['Type']
          }}
          enableGlobalFilter
          enableGrouping
          //enableRowSelection //enable some features
          enableColumnOrdering
          enableColumnResizing
          enableColumnFilters
          enableRowNumbers
          muiTopToolbarProps={{
            sx: { backgroundColor: theme.palette.primary.main, color: theme.palette.primary.contrastText }
          }}
          muiBottomToolbarProps={{
            sx: { backgroundColor: theme.palette.primary.main, color: theme.palette.primary.contrastText }
          }}
          renderTopToolbarCustomActions={() => (
            <Box>

              <Button size="small"
                variant="standard" sx={{ borderRadius: '25px' }} endIcon={<AddSharp style={{ width: "20px", height: "20px" }} />}>
                <SettingModel
                  icon={
                    <div>Add</div>
                  }
                  data=""
                  ChartofAccountParent={settingList.filter(st => st.Type === 'Chart of Account Category')}
                  Title="ADD NEW SETTING"
                  CategoriesList={settingList}
                  setParentUpdate={setUpdate}
                  ParentUpdate={update}
                />
              </Button>|

              {/*   <IconButton>
                    <label htmlFor="file">
                      {<FileUpload style={{ width: "20px", height: "20px" }} />}
                    </label>
                    <input
                      id="file"
                      name="file"
                      hidden
                      type="file"
                      onChange={handleUploadFile}
                    />
                   
                  </IconButton> */}

              <Button size="small"
                variant="standard" type="file" onClick={handleDownloadFile} sx={{ borderRadius: '25px' }} endIcon={<FileDownload style={{ width: "20px", height: "20px" }} />}>
                Download
              </Button>|

              <Button onClick={() => setUpdate(!update)} size="small"
                variant="standard" sx={{ borderRadius: '25px' }} endIcon={<RefreshSharp style={{ width: "20px", height: "20px" }} />}>
                Refresh
              </Button>

            </Box>
          )}
          enableRowActions
          renderRowActions={(table) => (
            <Box>
              <Tooltip title={t("modify")}>
                <IconButton >

                  <SettingModel
                    icon={<EditSharp style={{ width: "20px", height: "20px" }} />}
                    data={table.row.original}
                    ChartofAccountParent={settingList.filter(st => st.Type === 'Chart of Account Category')}

                    Title="EDIT SETTING"
                    CategoriesList={settingList}
                    setParentUpdate={setUpdate}
                    ParentUpdate={update}
                  />
                </IconButton>
              </Tooltip>
            </Box>
          )}
        ></MaterialReactTable>

      </Grid>

      <Grid item xs={12} className="hideInFull" mt={1}>
        <Box sx={{ width: "100%", backgroundColor: theme.palette.primary.main, color: theme.palette.primary.contrastText }}>


          <Button size="small"
            variant="standard" sx={{ borderRadius: '25px' }} endIcon={<AddSharp style={{ width: "20px", height: "20px" }} />}>
            <SettingModel
              icon={
                <div>Add</div>
              }
              data=""
              ChartofAccountParent={settingList.filter(st => st.Type === 'Chart of Account Category')}

              Title="ADD NEW SETTING"
              CategoriesList={settingList}
              setParentUpdate={setUpdate}
              ParentUpdate={update}
            />
          </Button>|

          {/*   <IconButton>
                       <label htmlFor="file">
                         {<FileUpload style={{ width: "20px", height: "20px" }} />}
                       </label>
                       <input
                         id="file"
                         name="file"
                         hidden
                         type="file"
                         onChange={handleUploadFile}
                       />
                      
                     </IconButton> */}

          <Button size="small"
            variant="standard" type="file" onClick={handleDownloadFile} sx={{ borderRadius: '25px' }} endIcon={<FileDownload style={{ width: "20px", height: "20px" }} />}>
            Download
          </Button>|

          <Button onClick={() => setUpdate(!update)} size="small"
            variant="standard" sx={{ borderRadius: '25px' }} endIcon={<RefreshSharp style={{ width: "20px", height: "20px" }} />}>
            Refresh
          </Button>

        </Box>
      </Grid>
      {!(settingList === undefined) &&
        settingList.length > 0 &&
        settingList.map((item) => {
          return (
            <Grid item key={item.Id} xs={12} m={1} className="hideInFull">
              <Card sx={{ borderRadius: 10, boxShadow: 3, width: "100%" }} >
                <CardHeader
                  avatar={
                    <Avatar
                      src={
                        item.Picture != null && item.Picture.length > 0
                          ? item.Picture.split(",")[0]
                          : "/Images/Products/default.png"
                      }
                    />
                  }
                  className="CardHeader"
                  title={"Type: " + item.Type} //.substring(0, 20)}

                />

                <CardContent>
                  <Typography variant="body2" align="left">
                    Description: {item.Description}
                  </Typography>

                </CardContent>
                <CardActions
                  sx={{
                    backgroundColor: theme.palette.primary.main,
                    color: theme.palette.primary.contrastText,
                  }}>
                  <Box>
                    <Tooltip title="Edit Payment">
                      <IconButton>
                        <SettingModel
                          icon={
                            <EditSharp
                              style={{ width: "20px", height: "20px" }}
                            />
                          }
                          data={item}
                          ChartofAccountParent={settingList.filter(st => st.Type === 'Chart of Account Category')}

                          Title="EDIT SETTING"
                          CategoriesList={settingList}
                          setParentUpdate={setUpdate}
                          ParentUpdate={update}
                        />
                      </IconButton>
                    </Tooltip>
                  </Box>
                </CardActions>
              </Card>
            </Grid>
          );
        })}

    </Grid>


  );
}

export default SettingComp;
